import React from "react";
import ReactDOM from "react-dom";
import { Modal, Icon, Button } from "antd";
import { ModalProps, ModalFunc, ModalFuncProps } from "antd/lib/modal/Modal";
import "antd/lib/modal/style";
import "antd/lib/icon/style";
import "antd/lib/button/style";
import "./VhModal.scss";

/**
 * 共同Modal
 *
 * @class VhModal
 * @extends {React.Component<ModalProps>}
 */
class VhModal extends React.Component<ModalProps> {
  public static confirm: ModalFunc;
  public static info: ModalFunc;
  public static success: ModalFunc;
  public static error: ModalFunc;
  public static warning: ModalFunc;

  /**
   * 渲染模板
   *
   * @returns
   * @memberof VhModal
   */
  public render() {
    let className = "vh-modal-default";

    if (this.props.className) {
      className = `${className} ${this.props.className}`;
    }

    return (
      <Modal destroyOnClose={ true } maskClosable={ false } okButtonProps={{shape: "round"}} cancelButtonProps={{shape: "round"}} keyboard={ false } {...this.props} className={ className } />
    )
  }
}

VhModal.confirm = (props: ModalFuncProps) => {
  const config = {
    type: "confirm",
    iconType: "exclamation-circle",
    title: "确认",
    ...props
  };
  return confirm(config);
};

VhModal.info = (props: ModalFuncProps) => {
  const config = {
    type: "info",
    iconType: "info-circle",
    title: "提示",
    ...props
  };
  return confirm(config);
};

VhModal.success = (props: ModalFuncProps) => {
  const config = {
    type: "success",
    iconType: "check-circle",
    title: "成功",
    ...props
  };
  return confirm(config);
};

VhModal.error = (props: ModalFuncProps) => {
  const config = {
    type: "error",
    iconType: "close-circle",
    title: "错误",
    ...props
  };
  return confirm(config);
};

VhModal.warning = (props: ModalFuncProps) => {
  const config = {
    type: "warning",
    iconType: "exclamation-circle",
    title: "警告",
    ...props
  };
  return confirm(config);
};

function confirm(this: any, config: ModalFuncProps) {
  const div = document.createElement("div");
  document.body.appendChild(div);

  const title = <div style={ {textAlign: "center", fontSize: 22} }>
    <Icon type={ config.iconType || "question-circle" } className={ `${config.type}-color` } style={ {marginRight: 12} } />
    { config.title }
  </div>;
  const buttonStyles = {width: 110, height: 35};
  const footer = <div style={ {textAlign: "center"} }>
    { config.type === "confirm" ? <Button key="back" style={ {...buttonStyles} } onClick={ close } shape="round">取消</Button> : null }
    <Button onClick={ close.bind(this, {triggerOk: true}) } style={ {...buttonStyles, marginLeft: 20} } type="primary" shape="round">
      确定
    </Button>
  </div>;

  let currentConfig = {
    ...config,
    close,
    title,
    visible: true,
    maskClosable: false,
    closable: false,
    bodyStyle: {textAlign: "center"},
    footer,
    className: "vh-modal-confirm-default"
  } as any;
  function close(this: any, ...args: any[]) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: destroy.bind(this, ...args),
    };
    render(currentConfig);
  }
  function update(newConfig: ModalFuncProps) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    };
    render(currentConfig);
  }
  function destroy(...args: any[]) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerOk = args.some(param => param && param.triggerOk);
    if (config.onOk && triggerOk) {
      config.onOk(...args);
    }
  }
  function render(props: any) {
    ReactDOM.render(<VhModal { ...props }>{ props.content }</VhModal>, div);
  }
  render(currentConfig);
  return {
    destroy: close,
    update
  };
}

export default VhModal;
